import React from "react";

import FlatButton from "material-ui/FlatButton";
import GiftDetailsOverlay from "../overlays/gift-details-overlay.jsx";

class BoxOfficeGiftDetailsSetup extends React.Component {
  constructor(props) {
    super(props);
    // Initialize state or bind methods here

    this.state = {
      editing: null
    };

    this.closeEditor = this.closeEditor.bind(this);
  }

  componentDidMount() {
    // Fetch data or perform other setup tasks here
  }

  closeEditor() {
    this.setState({ editing: null });
  }

  updateGiftCard(index, updatedData) {
    let subitems = this.props.orderData.subitems;
    subitems[index].recipientName = updatedData.recipientName;
    subitems[index].recipientEmail = updatedData.recipientEmail;
    subitems[index].giftMessage = updatedData.giftMessage;
    subitems[index].giftScheduledSend = updatedData.giftScheduledSend;
    this.props.updateCurrentOrder({ subitems });
  }

  getStyles() {
    return {
      editGiftCardButton: {
        border: "1px solid",
        lineHeight: "33px",
        marginRight: 7
      }
    };
  }

  render() {
    const { orderData, headerStyle } = this.props;
    const { editing } = this.state;
    const styles = this.getStyles();

    const giftCardIndices = orderData.subitems
      ? orderData.subitems
          .map((item, index) => (item.gift_card ? index : null))
          .filter(item => item !== null)
      : [];

    if (!giftCardIndices.length) {
      return null;
    }

    return (
      <div>
        {editing ? (
          <GiftDetailsOverlay
            orderData={this.props.orderData}
            giftCardIndex={editing.index}
            giftCardDetails={editing.item}
            requestClose={this.closeEditor}
            onSubmit={(index, data) => {
              this.updateGiftCard(index, data);
              this.closeEditor();
            }}
          />
        ) : null}
        <div style={headerStyle}>Gift Card Details</div>
        <p>Select each new gift card to edit gift card details</p>
        {giftCardIndices.map(index => (
          <FlatButton
            key={index}
            label={`Gift Card ${index + 1} Details`}
            style={styles.editGiftCardButton}
            onClick={() =>
              this.setState({
                editing: { index, item: orderData.subitems[index] }
              })
            }
          />
        ))}
      </div>
    );
  }
}

export default BoxOfficeGiftDetailsSetup;



// WEBPACK FOOTER //
// ./src/app/components/partials/box-office/box-office-gift-details-setup.jsx